<template>
  <ParticleAnim class="contact-section-wrapper" :class="{ 'theme--light': !$vuetify.theme.dark }">
    <v-container class="fill-height py-5 d-flex justify-center align-center">
      <!-- Get In Touch Section Component -->
      <GetInTouchSection
        :social-media="socialMedia"
        :title="'Get In Touch'"
        :description="'I\'d love to hear from you! Whether you have a project in mind, want to collaborate, or just say hello, don\'t hesitate to reach out.'"
        :response-time="'< 24hrs'"
        :satisfaction-rate="'98%'"
      />
    </v-container>
  </ParticleAnim>
</template>

<script>
import ParticleAnim from '@/components/ParticleAnim.vue';
import GetInTouchSection from '@/components/subcomponents/GetInTouchSection.vue';

export default {
  components: {
    ParticleAnim,
    GetInTouchSection
  },
  data() {
    return {

      socialMedia: [
        {
          name: "WhatsApp",
          icon: "fab fa-whatsapp",
          color: "#25D366", // WhatsApp green
          link: "https://wa.me/+233597537575"  // WhatsApp direct link
        },
        {
          name: "Telegram",
          icon: "fab fa-telegram-plane",
          color: "#0088cc", // Telegram blue
          link: "https://t.me/tech_cg"  // Telegram direct link
        },
        {
          name: "Facebook",
          icon: "fab fa-facebook-f",
          color: "#3b5998", // Facebook color
          link: "https://facebook.com/kalculusGuy"
        },
        {
          name: "X-Twitter",
          icon: "fab fa-x-twitter",
          color: "#000", // X brand color
          link: "https://x.com/kalculusGuy"
        },
        {
          name: "LinkedIn",
          icon: "fab fa-linkedin-in",
          color: "#0077b5", // LinkedIn color
          link: "https://linkedin.com/in/kalculus-guy-915192306"
        },
        {
          name: "GitHub",
          icon: "fab fa-github",
          color: "#333333", // GitHub color
          link: "https://github.com/odeneho-calculus"
        },
      ],
    };
  },
  // No methods needed for social-only contact section
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

/* Theme-aware background wrapper - overrides particles */
.contact-section-wrapper {
  position: relative;
  overflow: hidden;
  min-height: 100vh;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      #0a0a0a 0%,
      #1a1a2e 50%,
      #16213e 100%
    );
    z-index: 1;
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, rgba(67, 97, 238, 0.05), rgba(72, 149, 239, 0.05));
    z-index: 1;
  }

  /* Light theme styling */
  &.theme--light {
    &::before {
      background: linear-gradient(
        135deg,
        #f8f9fa 0%,
        #e9ecef 50%,
        #dee2e6 100%
      );
    }

    &::after {
      background: linear-gradient(135deg, rgba(67, 97, 238, 0.03), rgba(72, 149, 239, 0.03));
    }
  }

  .v-container {
    position: relative;
    z-index: 2;
  }
}

.fill-height {
  min-height: calc(100vh - 100px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
